export const listAdminTypeOptions = [
    {value: 1, text: "Broker/Agent"},
];

export const PafStatusOptions = [
    {value: -1, text: "None"},
    {value: 1, text: "Saved"},
    {value: 2, text: "Active"},
    {value: 3, text: "Pending"},
    {value: 4, text: "Pending Renewal"},
    {value: -100, text: "Canceled"},
];

export const PafSignatureStatusOptions = [
    {value: -1, text: "None"},
    {value: 1, text: "Pending BALA Signature"},
    {value: 2, text: "BALA Signed"},
    {value: 3, text: "Pending List Owner Signature"},
    {value: 4, text: "List Owner Signed"},
    {value: 5, text: "Pending Licensee Signature"},
    {value: 6, text: "Licensee Signed"},
    {value: -100, text: "Canceled"},
];

